var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collection, doc, getDoc, getDocs, query, setDoc, where } from 'firebase/firestore';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { useDocument } from 'react-firebase-hooks/firestore';
import { FirebaseAppContext, FirebaseAuthContext } from 'libs.firebase_react';
import { CodedError } from 'libs.localization.common';
import { Localization } from 'libs.localization.web';
export function useLocalization(asset) {
    const { db } = useContext(FirebaseAppContext);
    const { userClaims, loading: loadingAuth, error: errorAuth } = useContext(FirebaseAuthContext);
    const entityId = userClaims === null || userClaims === void 0 ? void 0 : userClaims.entityId;
    const localization = useMemo(() => {
        if (!asset) {
            return undefined;
        }
        try {
            return new Localization(asset);
        }
        catch (error) {
            if (!(error instanceof CodedError && error.code === 'E_ASSET_NOT_SUPPORTED')) {
                throw error;
            }
            console.error(error.message, asset);
            return undefined;
        }
    }, [asset]);
    const localizationQuery = useMemo(() => {
        if (entityId && localization) {
            const id = localization.getId();
            const isProductStrings = /product_/.test(id);
            const collectionPath = isProductStrings ? `localization` : `entities/${entityId}/localization`;
            return doc(db, collectionPath, id);
        }
        return null;
    }, [db, entityId, localization]);
    const [snapshot, loadingFirestore, errorFirestore] = useDocument(localizationQuery);
    const entry = loadingFirestore ? {} : (snapshot === null || snapshot === void 0 ? void 0 : snapshot.data()) || {};
    useEffect(() => {
        if (db && localization && entityId) {
            localization.configureLocalizationDatabase(doc, getDoc, setDoc, collection, query, where, getDocs, db, String(entityId));
        }
    }, [localization, db, entityId]);
    const setLocalizationHook = useCallback(function (entry) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!localization) {
                return;
            }
            return yield localization.updateDatabaseEntry(entry);
        });
    }, [localization]);
    const isScreenReportReady = useCallback((locale, productVersion, version, viewport) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const latestVersion = (_b = (_a = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _a === void 0 ? void 0 : _a[locale]) === null || _b === void 0 ? void 0 : _b.version;
        const defaultViewport = (_d = (_c = entry === null || entry === void 0 ? void 0 : entry.metadata) === null || _c === void 0 ? void 0 : _c.preview) === null || _d === void 0 ? void 0 : _d.default_viewport;
        if (loadingFirestore || !locale || !latestVersion || !defaultViewport) {
            return false;
        }
        const product = productVersion !== null && productVersion !== void 0 ? productVersion : 'r300';
        return (((_k = (_j = (_h = (_g = (_f = (_e = entry.metadata) === null || _e === void 0 ? void 0 : _e.preview) === null || _f === void 0 ? void 0 : _f.is_ready_v3) === null || _g === void 0 ? void 0 : _g[product]) === null || _h === void 0 ? void 0 : _h[String(locale)]) === null || _j === void 0 ? void 0 : _j[version || latestVersion]) === null || _k === void 0 ? void 0 : _k[viewport || defaultViewport]) === true);
    }, [loadingFirestore, entry]);
    return {
        isLoading: loadingAuth || loadingFirestore,
        localization,
        localizationEntry: entry,
        isScreenReportReady,
        error: errorAuth || errorFirestore,
        setLocalization: setLocalizationHook,
    };
}
//# sourceMappingURL=localization.hook.js.map